import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, ClockIcon, SparklesIcon } from 'lucide-react';
const steps = [{
  number: 1,
  icon: DownloadIcon,
  title: 'Descarga el Método',
  description: 'Recibes acceso inmediato a tu guía en PDF para leerla en tu celular.'
}, {
  number: 2,
  icon: ClockIcon,
  title: 'Sigue el Horario',
  description: 'Identifica la ventana de sueño de tu bebé hoy mismo con nuestra tabla.'
}, {
  number: 3,
  icon: SparklesIcon,
  title: 'Aplica los 7 Minutos',
  description: 'Ejecuta el protocolo sensorial y mira cómo tu bebé se entrega al sueño sin pelear.'
}];
export function HowItWorksSection() {
  return <section className="w-full bg-gradient-to-b from-[#1e293b] to-[#0f172a] py-16 md:py-24" data-id="element-79">
      <div className="max-w-5xl mx-auto px-4" data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-81">
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl font-bold text-white text-center mb-16" data-id="element-82">
            Así de Fácil <span className="text-[#d4a853]" data-id="element-83">Funciona</span>
          </h2>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-84">
            {steps.map((step, index) => <motion.div key={index} className="relative" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.15
          }} data-id="element-85">
                <div className="bg-[#0f172a]/60 border border-[#d4a853]/30 rounded-2xl p-8 text-center h-full" data-id="element-86">
                  {/* Number badge */}
                  <div className="w-12 h-12 bg-[#d4a853] rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-87">
                    <span className="font-['Playfair_Display'] text-2xl font-bold text-[#0f172a]" data-id="element-88">
                      {step.number}
                    </span>
                  </div>

                  {/* Icon */}
                  <div className="w-16 h-16 bg-[#1e293b] rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-89">
                    <step.icon className="w-8 h-8 text-[#f5c542]" data-id="element-90" />
                  </div>

                  <h3 className="font-['Playfair_Display'] text-xl md:text-2xl font-bold text-white mb-4" data-id="element-91">
                    {step.title}
                  </h3>

                  <p className="font-['DM_Sans'] text-gray-400 text-base leading-relaxed" data-id="element-92">
                    {step.description}
                  </p>
                </div>

                {/* Connector line (hidden on mobile and last item) */}
                {index < steps.length - 1 && <div className="hidden md:block absolute top-1/2 -right-4 w-8 h-0.5 bg-[#d4a853]/40" data-id="element-93" />}
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}